import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const currentYear = dayjs().year();
const currentYearShort = currentYear.toString().slice(-2);

const initialState = {
  startDate: null,
  endDate: null,
  selectedPeriod: "ytd",
  selectedPropertyId: "",
  selectedEntityType: "property",
  selectedPropertyGroupId: "",
};

export const cashflowFilterSlice = createSlice({
  name: "cashflowFilter",
  initialState,
  reducers: {
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setSelectedPeriod: (state, action) => {
      state.selectedPeriod = action.payload;
    },
    setSelectedPropertyId: (state, action) => {
      state.selectedPropertyId = action.payload;
    },
    setSelectedEntityType: (state, action) => {
      state.selectedEntityType = action.payload;
    },
    setSelectedPropertyGroupId: (state, action) => {
      state.selectedPropertyGroupId = action.payload;
    },
    resetCashflowFilters: (state) => {
      return { ...initialState };
    },
  },
});

export const {
  setStartDate: setCashflowStartDate,
  setEndDate: setCashflowEndDate,
  setSelectedPeriod: setCashflowSelectedPeriod,
  setSelectedPropertyId: setCashflowSelectedPropertyId,
  setSelectedEntityType: setCashflowSelectedEntityType,
  setSelectedPropertyGroupId: setCashflowSelectedPropertyGroupId,
  resetCashflowFilters,
} = cashflowFilterSlice.actions;

export default cashflowFilterSlice.reducer;
